import React from 'react';
import * as _ from 'lodash';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import { Confirmation } from '../modals/common';
import { FieldBulletinBoardMasterHeader } from './FieldBulletinBoardMasterHeader';

import { messageUtility } from '../../utilities/messageUtility';
import { BACK_EVENT_SOURCE } from '../../utilities/constants';

import MasterPageHeaderStyles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardMasterPageHeader.scss';
import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardForm.scss';

/**
 * 現場掲示板 ヘッダー
 * @param { function } handleBack
 * @param { string } masterHeadertitle
 * @param { any } breadcrumbsName
 * @param { function } closeConfirmDialog
 * @param { function } getModalDisplayInfo
 * @param { function } executeBack
 * @param { any } button
 * @param { any } status
 * @param { any } description
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardHeader(props) {
  const {
    handleBack,
    masterHeadertitle,
    breadcrumbsName,
    closeConfirmDialog,
    getModalDisplayInfo,
    executeBack,
    button,
    status,
    description,
  } = props;

  const modalDisplayInfo = getModalDisplayInfo();

  return (
    <React.Fragment>
      <div className={`${MasterPageHeaderStyles.masterPageHeader}`}>
        <FieldBulletinBoardMasterHeader
          handleBack={() => handleBack(BACK_EVENT_SOURCE.MASTER_PAGE_HEADER)}
          title={masterHeadertitle}
        />
      </div>
      {/* パンくず */}
      <div className={`${Styles.header}`}>
        <div className='board-header-left'>
          <div className='board__bread-crumb'>
            <KeyboardArrowLeftIcon className='arrow-icon' />
            <button
              className='btn-text--sm'
              onClick={() => handleBack(BACK_EVENT_SOURCE.BREADCRUMBS)}
            >
              {breadcrumbsName}
            </button>
          </div>
          {/* タイトル・ステータス*/}
          <div className='board-header-title'>
            <h1 className='header__title'>
              {messageUtility.getMessage('I-000-165-25')}
            </h1>
            {status && (
              <span className='board-header-title__publication-status'>
                {status}
              </span>
            )}
          </div>
        </div>
        {/* 備考 */}
        <div className='board-header-middle'>
          {description && (
            <div className='header-description__txt'>{description}</div>
          )}
        </div>
        {/* ボタン */}
        <div className='board-header-right'>
          {button && <div className='board-header-right__btn'>{button}</div>}
        </div>
      </div>

      {/* 編集をやめるダイアログ */}
      <Confirmation
        visible={_.has(modalDisplayInfo, 'back') && modalDisplayInfo.back}
        title={messageUtility.getMessage('I-000-025')}
        message={messageUtility.getMessage('I-000-confirmCloseEditWindow')}
        isNegative={true}
        confirmButtonText={messageUtility.getMessage('I-000-closeEditWindow')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={() => executeBack()}
        onCancel={() => closeConfirmDialog()}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardHeader.jsx